import styled from 'styled-components'

const Container = styled.div``

const Author = styled.p``

export {
    Container,
    Author
}